import { computed } from 'vue'

import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useSelectedMobilePlan() {
  const { data: product } = useFetchProduct()
  const { mobilePlan: mobilePlanOfferId } = useUrlParams()

  return computed(() => {
    if (!mobilePlanOfferId.value) return undefined

    return product.value?.includedServiceOffers.mobilePlans.find(
      ({ id }) => id === mobilePlanOfferId.value,
    )
  })
}
